import { DropdownActiveIcon, DropdownIcon } from '@components/atoms';
import type { CollapseButtonComponentProps } from '@components/molecules';
import { Button, ButtonSize, ButtonVariant } from '@components/molecules';

const DropdownButton: CollapseButtonComponentProps = ({ isActive, ariaControls, ariaLabelledBy, onToggle, disabled }) => {
	return (
		<Button
			onClick={onToggle}
			variant={ButtonVariant.ICON}
			size={ButtonSize.XS}
			aria-expanded={!isActive}
			aria-controls={ariaControls}
			aria-labelledby={ariaLabelledBy}
			disabled={disabled}
			type="button"
			id="dropdown-button"
		>
			{isActive ? <DropdownIcon /> : <DropdownActiveIcon />}
		</Button>
	);
};

export { DropdownButton };
